module.exports = __webpack_public_path__ + "static/media/cash-receive.a972f968.svg";